import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "header" };
const _hoisted_2 = { class: "logo" };
const _hoisted_3 = { class: "sidebar" };
const _hoisted_4 = { class: "content" };
import { useRoute } from 'vue-router';
import { APP_NAME } from '@/constants/base';
import { useComments, useComplaints, useCurrenciesStore, useGameImageStore, useLocalesStore, useCategoryCollectionsStore, useCollectionsStore, useProvidersFees, useProvidersDiscounts, useTenantStore, useHotColdCollectionsStore, } from '@/store';
import { onMounted } from 'vue';
import { useAggregators } from '@/store/aggregators';
import { useStopPhrases } from '@/store/stop-phrases';
import { useSidebarPosition } from './useSidebarPosition';
import Logo from './components/Logo.vue';
import Navbar from './components/Navbar.vue';
import Sidebar from './components/Sidebar/Sidebar.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Layout',
    setup(__props) {
        const { isCollapsed, toggleCollapse } = useSidebarPosition();
        const aggregatorsStore = useAggregators();
        const currenciesStore = useCurrenciesStore();
        const gameImageStore = useGameImageStore();
        const commentsStore = useComments();
        const complaintsStore = useComplaints();
        const stopPhrasesStore = useStopPhrases();
        const localesStore = useLocalesStore();
        const collectionsStore = useCollectionsStore();
        const categoryCollectionsStore = useCategoryCollectionsStore();
        const providersFeesStore = useProvidersFees();
        const providersDiscountsStore = useProvidersDiscounts();
        const hotColdCollectionStore = useHotColdCollectionsStore();
        const tenantStore = useTenantStore();
        const currentRoute = useRoute();
        onMounted(() => {
            localesStore.init();
            aggregatorsStore.init();
            currenciesStore.init();
            gameImageStore.init();
            commentsStore.init();
            complaintsStore.init();
            stopPhrasesStore.init();
            collectionsStore.init();
            categoryCollectionsStore.init();
            providersFeesStore.init();
            providersDiscountsStore.init();
            hotColdCollectionStore.init();
            tenantStore.fetchCurrentTenant();
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["grid w-full h-full overflow-hidden app", { app_collapsed: _unref(isCollapsed) }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(Navbar, {
                        isMenuCollapsed: _unref(isCollapsed),
                        toggleMenuCollapse: _unref(toggleCollapse)
                    }, null, 8, ["isMenuCollapsed", "toggleMenuCollapse"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Logo, {
                        "app-title": _unref(APP_NAME),
                        isSmall: _unref(isCollapsed)
                    }, null, 8, ["app-title", "isSmall"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(Sidebar, { isCollapsed: _unref(isCollapsed) }, null, 8, ["isCollapsed"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(), _createBlock(_component_router_view, {
                        key: _unref(currentRoute).path
                    }))
                ])
            ], 2));
        };
    }
});
